import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { s as styleInject } from '../../style-inject.es-746bb8ed.js';
import classnames from 'classnames';
import { getScaleImageSrc } from 'wix-rich-content-common/libs/imageUtils';

var css_248z = ".vxIpM{grid-column-gap:20px;display:grid;grid-template-areas:\"img title\" \"img description\";grid-template-columns:max-content auto;width:calc(100% - 24px)}[dir] .vxIpM{cursor:pointer;padding:17px 0}[dir] .vxIpM.yM3O7{background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.1)}[dir] .vxIpM:hover:not(.yM3O7){background-color:rgba(var(--ricos-settings-action-color-tuple,var(--ricos-fallback-color-tuple,0,0,0)),.06)}.vxIpM ._9jdLG{flex:0 0 auto;grid-area:img;height:48px;width:48px}[dir] .vxIpM ._9jdLG{background-color:#ccc;background-position:50%;background-repeat:no-repeat;background-size:cover}[dir=ltr] .vxIpM ._9jdLG{margin-left:17px}[dir=rtl] .vxIpM ._9jdLG{margin-right:17px}.vxIpM .IcRbw,.vxIpM .Tfo-R{color:var(--ricos-settings-text-color,#000);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}[dir=ltr] .vxIpM .IcRbw,[dir=ltr] .vxIpM .Tfo-R{padding-right:36px}[dir=rtl] .vxIpM .IcRbw,[dir=rtl] .vxIpM .Tfo-R{padding-left:36px}.vxIpM .Tfo-R{font-size:16px;grid-area:title;line-height:24px}.vxIpM .IcRbw{font-size:14px;grid-area:description;line-height:1.43;opacity:.6}@media only screen and (max-width:800px){.Tfo-R{font-size:14px;line-height:1.43}.IcRbw{font-size:12px;line-height:1.33}}";
var styles = {"container":"vxIpM","selected":"yM3O7","image":"_9jdLG","title":"Tfo-R","description":"IcRbw"};
styleInject(css_248z);

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class Item extends PureComponent {
  constructor() {
    super(...arguments);
    __publicField(this, "itemRef", React.createRef());
    __publicField(this, "handleClick", () => this.props.onClick(this.props.item));
  }
  componentDidMount() {
    var _a;
    this.props.selected && ((_a = this.itemRef) == null ? void 0 : _a.current.scrollIntoView());
  }
  render() {
    const { selected, item, t } = this.props;
    const { name, getDescription } = item;
    const imageSrc = getScaleImageSrc(item.imageSrc, 50, 50);
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        ref: this.itemRef,
        className: classnames(styles.container, selected && styles.selected),
        onClick: this.handleClick
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          style: { backgroundImage: `url(${imageSrc})` },
          className: styles.image,
          "data-hook": "verticalsImage"
        }
      ),
      /* @__PURE__ */ React.createElement("div", { className: styles.title }, name),
      getDescription && /* @__PURE__ */ React.createElement("div", { className: styles.description }, getDescription(item))
    );
  }
}
__publicField(Item, "propTypes", {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  t: PropTypes.func.isRequired
});

export { Item as default };
//# sourceMappingURL=Item.js.map
